module.exports = __webpack_public_path__ + "img/likesOrderOn.41a08d63.svg";